module.exports = __webpack_public_path__ + "img/rightpop.109a515b.png";